import { createI18n } from "vue-i18n";
import messages from "./messages";

const supportedLocales = ["th", "en"];
const storedLocale = localStorage.getItem("ucanbuy-locale") || "th";
const locale = supportedLocales.includes(storedLocale) ? storedLocale : "th";

if (storedLocale !== locale) {
  localStorage.setItem("ucanbuy-locale", locale);
}

export default createI18n({
  legacy: false,
  locale,
  fallbackLocale: "th",
  messages
});
